import { useCallback, type ReactNode } from 'react'
import { ComplianceViolationsList, EmptyComplianceViolations, NotReady, Page } from '@components'
import { useComplianceViolations } from '@front/model'
import { useNavigate, createFileRoute } from '@tanstack/react-router'
import { type WithComplianceViolationId, type CompliancePolicyId, type UserId, isNotEmpty } from '@terros/common'

type Params = {
  entityId?: CompliancePolicyId | UserId
}

function ViewCompliancePolicyViolations(): ReactNode {
  const navigate = useNavigate()

  const { data, isLoading, error, refetch, isFetching } = useComplianceViolations()

  const onClick = useCallback(
    ({ violationId }: WithComplianceViolationId): void => {
      navigate({ to: `/compliance/violation/${violationId}` })
    },
    [navigate]
  )

  return (
    <Page>
      <Page.Heading title='View Violations' back goBackBehavior='history' refetch={refetch} isFetching={isFetching} />
      <Page.Content scrollArea>
        <NotReady data={data} error={error} id='Policy' isLoading={isLoading}>
          {isNotEmpty(data) ? (
            <ComplianceViolationsList violations={data} onClick={onClick} />
          ) : (
            <EmptyComplianceViolations />
          )}
        </NotReady>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/compliance_/violations/')({
  component: ViewCompliancePolicyViolations,
})
